import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import "./about-time-line.scss";

const timeLineElements = [
  {
    side: "left",
    year: "1997",
    text: 'Fondazione "Costruzioni Generali Violato Ivano" a Conselve (PD)',
  },
  {
    side: "right",
    year: "2000",
    text: "Secondo brevetto e specializzazione in Pali Rotoinfissi",
  },
  {
    side: "left",
    year: "2005",
    text: "Coinvolgimento dei figli del fondatore nell'attività",
  },
  {
    side: "right",
    year: "2015",
    text: "Costituzione di Rotoinfissioni SRL",
  },
  {
    side: "left",
    year: "Oggi",
    text: "Leader nelle opere di consolidamento e fondazione con tecnologie all'avanguardia",
  },
];

const AboutTimeLine = () => {
  return (
    <section className="about-time-line">
      <IntroSectionBadge
        title={"La Nostra Storia"}
        text={
          "Un percorso di crescita e innovazione nelle opere di fondazione e consolidamento"
        }
        bgColor={"dark"}
      />
      <div className="about-time-line__container">
        {timeLineElements.map((item, i) => (
          <div
            className={`about-time-line__item about-time-line__item--${item.side}`}
          >
            <Fade
              key={i}
              direction={item.side === "left" ? "left" : "right"}
              duration={800}
              delay={i * 150}
              triggerOnce
            >
              <span className="about-time-line__year">{item.year}</span>
              <p className="about-time-line__text">{item.text}</p>
            </Fade>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutTimeLine;
